import { c as _c } from "react/compiler-runtime";
import { useCallback, useLayoutEffect, useState } from "react";
export function useElementDimensions(ref) {
  const $ = _c(9);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      width: 0,
      height: 0,
      top: 0,
      left: 0
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [size, setSize] = useState(t0);
  let t1;
  if ($[1] !== ref) {
    t1 = () => {
      if (!ref.current) {
        return;
      }
      setSize(ref.current.getBoundingClientRect());
    };
    $[1] = ref;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const measure = t1;
  let t2;
  let t3;
  if ($[3] !== measure) {
    t2 = () => {
      measure();
    };
    t3 = [measure];
    $[3] = measure;
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  useLayoutEffect(t2, t3);
  let t4;
  if ($[6] !== measure || $[7] !== size) {
    t4 = [size, measure];
    $[6] = measure;
    $[7] = size;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
}